import { render } from "./InternalPageNode.vue?vue&type=template&id=1c6775d4"
import script from "./InternalPageNode.vue?vue&type=script&lang=js"
export * from "./InternalPageNode.vue?vue&type=script&lang=js"

import "./InternalPageNode.vue?vue&type=style&index=0&id=1c6775d4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__